module.exports = ".SpaceBottom{\n    margin-bottom: 50px;\n}"